import { ProductType } from 'components/product/product-type/ProductType'
import { useLocation, useSearchParams } from 'react-router-dom'
import { constructOptionMultipleSelect, convertErrorMessage, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/product/configTableProductType'
import { useEffect, useState } from 'react'
import { ACTION_TYPE } from 'constants/constant'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT_TYPE } from 'services/apiProductType'
import { Alert } from 'avo-ui'
import { useValidation } from 'hooks/useValidation'
import { PRODUCT_TYPE_VALIDATION } from 'services/validation/productTypeValidation'

const INIT_STATE = {
    name: null,
    description: null,
    product_ids: [],
}

const FIELD_NAME_DETAIL = {
    name: 'Nama produk type',
    description: 'Deskripsi',
    product_ids: 'Produk list',
}

export const ProductTypeContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [productTypeDetail, setProductTypeDetail] = useState({})
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getProductTypeList, data: productTypeList, isLoading } = useFetch(API_PRODUCT_TYPE.LIST)
    const { fetching: deleteProductType, isLoading: isDeleting } = useFetch(API_PRODUCT_TYPE.DELETE)
    const { fetching: getProductList } = useFetch(API_PRODUCT_TYPE.PRODUCT_LIST)
    const { fetching: detailProductType, isLoading: isLoadingDetail } = useFetch(API_PRODUCT_TYPE.DETAIL)
    const { fetching: createProductType, isLoading: isCreating } = useFetch(API_PRODUCT_TYPE.CREATE)
    const { fetching: updateProductType, isLoading: isUpdating } = useFetch(API_PRODUCT_TYPE.UPDATE)
    const [optionsProduct, setOptionsProduct] = useState([])
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: productTypeDetail,
        schema: PRODUCT_TYPE_VALIDATION,
    })
    const [modal, setModal] = useState({
        delete: false,
        form: false,
    })

    useEffect(() => {
        fetchProductTypeList()
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id', 'product_image_url')
            setOptionsProduct(newList)
        })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onActionRow = ({ id, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setProductTypeDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                detailProductType({}, id).then((response) => {
                    const newDetail = {
                        ...response?.data,
                        product_ids: constructOptionMultipleSelect(
                            response?.data?.products,
                            'name',
                            'id',
                            'product_image_url',
                        ),
                    }
                    setProductTypeDetail(newDetail)
                })
                setShowModal({ form: true })
                break
            default:
                setShowModal({ delete: true })
        }
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const fetchProductTypeList = (item = { ...query }) => {
        getProductTypeList(item)
    }

    const onHideForm = () => {
        setShowModal({ form: false })
        setErrorMessage({})
        clearErrorForm()
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setProductTypeDetail({ ...productTypeDetail, [name]: value })
    }

    const onDelete = () => {
        deleteProductType({ ids: selectedIds }).then(() => {
            setIsResetSelectedItem(!isResetSelectedItem)
            setShowAlert('Product Type Deleted !', { delete: false })
            if (productTypeList?.data?.results?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchProductTypeList()
            }
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const newDetail = {
                ...productTypeDetail,
                product_ids: productTypeDetail?.product_ids?.map((i) => i?.value),
            }
            const { id, products, ...payload } = newDetail
            if (!id) {
                createProductType(payload)
                    .then(() => {
                        setShowAlert('Product Type Created !', { form: false })
                        fetchProductTypeList()
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            } else {
                updateProductType(payload, id)
                    .then(() => {
                        setShowAlert('Product Type Updated !', { form: false })
                        fetchProductTypeList()
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            }
        })
    }

    const props = {
        dataList: productTypeList?.data,
        query,
        onChangeQuery,
        onActionRow,
        selectedIds,
        onSelectItemHandler,
        modal,
        setShowModal,
        onDelete,
        productTypeDetail,
        optionsProduct,
        onSearchProduct,
        onHideForm,
        onChangeForm,
        errorForm: { ...errorForm, ...errorMessage },
        onSubmit,
        isLoading,
        isLoadingDetail,
        isDeleting,
        isCreating,
        isUpdating,
        isResetSelectedItem,
    }

    return <ProductType {...props} />
}
